import Vue from "vue";

const initialNotify = { message: null, code: null };

export const state = {
    dataMessage: null
}
export const mutations = {
    SET_NOTIFY_MESSAGE(state, newValue) {
        state.dataMessage = newValue
    },
}
export const actions = {
    async addNotify({ commit }, data = initialNotify) {
        commit("SET_NOTIFY_MESSAGE", data);
    }
}
